import { createSlice } from '@reduxjs/toolkit';

const SelectedSpace = createSlice({
    name: 'selectedSpace',
    initialState:{
        selectedValues:[]
    },
    reducers:{
        setSelectedValues:(state,action)=>{
            state.selectedValues = action.payload;
        }
    }
})

export const {setSelectedValues } = SelectedSpace.actions;
export default SelectedSpace.reducer;